import styles from "../styles/social-media-sidebar-section.module.scss";
import { sideBarSocialMedias } from "@/data/social-medias";
import Link from "next/link";
import Image from "next/image";
import { useMobile } from "@/hooks/use-responsive";

const SocialMediaSidebarSection = () => {
  const { isMobile } = useMobile();
  return (
    <div className={styles.wrapper}>
      {sideBarSocialMedias.map((socialMedia) => (
        <Link
          href={socialMedia.servicePageUrl!}
          key={socialMedia.title}
          target={"_blank"}
        >
          <Image
            src={socialMedia.icon}
            alt={""}
            width={isMobile ? 30 : 25}
            height={isMobile ? 30 : 25}
          />
        </Link>
      ))}
    </div>
  );
};

export default SocialMediaSidebarSection;
